export default __webpack_public_path__ + "static/media/template_business-man__0012_15---SosiaJia.5cb1ee61.png";